import { Typography } from "@mui/material";

export const DeleteModalContent = ({ label, value }: { label: string; value: string }) => {
  return (
    <Typography variant="body1">
      <Typography component="span" fontWeight={500}>
        {label}:{' '}
      </Typography>{' '}
      {value || ''}
    </Typography>
  )
}